export const updateAutoSave = ({ saving }) => ({
	type: "UPDATE_AUTO_SAVE",
	saving,
});

export const updateLastSaved = ({ lastSaved }) => ({
	type: "UPDATE_LAST_SAVED",
	lastSaved,
});
